const offsetToAbbr = {
  [-4]: "EDT", // Eastern Daylight Time
  [-5]: "EST", // Eastern Standard Time
  [-6]: "CST", // Central Standard Time
  [-7]: "MST", // Mountain Standard Time
  [-8]: "PST", // Pacific Standard Time
  [-9]: "AKST", // Alaska Standard Time
  [-10]: "HST", // Hawaii Standard Time
  // Add more as needed
};

export function getTimezoneAbbr(offset) {
  const dstOffset = isDST() ? offset - 1 : offset;
  return (
    offsetToAbbr[dstOffset] || `UTC${dstOffset >= 0 ? "+" : ""}${dstOffset}`
  );
}

function isDST() {
  const date = new Date();
  const jan = new Date(date.getFullYear(), 0, 1); // January 1st
  const jul = new Date(date.getFullYear(), 6, 1); // July 1st

  const currentOffset = date.getTimezoneOffset();
  const janOffset = jan.getTimezoneOffset();
  const julOffset = jul.getTimezoneOffset();

  // In most US timezones, DST is active when offset is less than winter offset
  return currentOffset < Math.max(janOffset, julOffset);
}

export function getTimezoneOffsetFromName(timeZone) {
  const date = new Date();
  const utcDate = new Date(date.toLocaleString("en-US", { timeZone: "UTC" }));
  const tzDate = new Date(date.toLocaleString("en-US", { timeZone }));
  return (tzDate.getTime() - utcDate.getTime()) / 6e4;
}

export function formatUserCounts(args) {
  const {
    userCounts,
    date,
    time,
    type = "sms",
    timezoneOffset = new Date().getTimezoneOffset() / -60,
    sendAtUserTime = true,
  } = args;

  return userCounts.map((userCount) => {
    const utcOffset = userCount.offset / 60 / 60;
    const dateString = `${date}T${time}:00`;

    // Create UTC date from input date, time, and timezoneOffset
    const utcDate = new Date(
      new Date(dateString).getTime() - timezoneOffset * 60 * 60 * 1000
    ).getTime();

    const timeInUserCountTimezone = new Date(
      utcDate + utcOffset * 60 * 60 * 1000
    ).toLocaleString("en-US", {
      hour12: true,
      timeStyle: "short",
    });

    // Convert date and time to UTC time (assuming input is already in proper timezoneOffset)
    const localTime = new Date(dateString);
    const utcTime = localTime; // Input time is already in the correct timezone
    const localTimeFormatted = new Date(localTime).toLocaleString("en-US", {
      hour12: true,
      timeStyle: "short",
    });

    // Time local to the user's timezone
    const userCountLocalTime = new Date(dateString).toLocaleString("en-US", {
      hour12: true,
      timeStyle: "short",
    });
    const userCountInTimezone = new Date(
      new Date(dateString).getTime() + utcOffset * 60 * 60 * 1000
    ).toLocaleString("en-US", {
      hour12: true,
      timeStyle: "short",
    });

    // Convert userCountLocalTime to your own timezone
    // Calculate the difference between user's timezone and your timezone
    const timezoneDifference = timezoneOffset - utcOffset;
    const userCountLocalTimeInYourTimezone = new Date(
      new Date(dateString).getTime() + timezoneDifference * 60 * 60 * 1000
    ).toLocaleString("en-US", {
      hour12: true,
      timeStyle: "short",
    });

    // Extract date and time from userCountLocalTime
    const userCountLocalTimeParts = userCountLocalTime.split(", ");
    const userCountLocalTimeDate = userCountLocalTimeParts[0];
    const userCountLocalTimeOnly =
      userCountLocalTimeParts[1] || userCountLocalTime;

    // Extract date and time from userCountLocalTimeInYourTimezone
    const yourTimezoneParts = userCountLocalTimeInYourTimezone.split(", ");
    const yourTimezoneDate = yourTimezoneParts[0];
    const yourTimezoneTimeOnly =
      yourTimezoneParts[1] || userCountLocalTimeInYourTimezone;

    // If dates match, only show time for your timezone
    const formattedYourTimezone =
      userCountLocalTimeDate === yourTimezoneDate
        ? yourTimezoneTimeOnly
        : userCountLocalTimeInYourTimezone;

    // Check if their_time is between 9AM-9PM
    const theirTimeDate = new Date(dateString);
    const theirTimeHour = theirTimeDate.getHours();
    const isAvailable = theirTimeHour >= 9 && theirTimeHour <= 21;

    return {
      ...userCount,
      available: type === "email" ? true : userCount.available || isAvailable,
      their_time: sendAtUserTime
        ? `${userCountLocalTime} ${getTimezoneAbbr(utcOffset)}`
        : `${timeInUserCountTimezone} ${getTimezoneAbbr(utcOffset)}`,
      your_time: sendAtUserTime
        ? `${formattedYourTimezone} ${getTimezoneAbbr(timezoneOffset)}`
        : `${localTimeFormatted} ${getTimezoneAbbr(timezoneOffset)}`,
    };
  });
}
